export function extractOptionalTranslation(args: {
  intl: any
  parentKey: string
  subKey: string
}) {
  let subKey = args.subKey
  const id = args.parentKey + "." + subKey
  if (args.intl.messages[id] !== undefined) {
    return args.intl.formatMessage({ id, defaultMessage: id })
  } else {
    console.error("Missing translation '" + id + "'")
    return args.subKey
  }
}
